import React, { useState } from 'react';
import { StyleSheet } from 'react-native';
import { Image, Box, Text } from 'native-base';

import main from '../../Assets/Styles/main.json';
const mainStyle = StyleSheet.create(main);

const UserImage = (props) => {
    const avatarUrl = props.user?.avatarUrl;
    const [failed, setFailed] = useState(false);

    const getInitials = () => {
        const first = props.user?.firstName?.[0]?.toUpperCase() || '';
        const last = props.user?.lastName?.[0]?.toUpperCase() || '';
        return first + last;
    };

    if (failed || !avatarUrl) {
        return (
            <Box
                style={[mainStyle.userCircle, props.style, {
                    justifyContent: 'center',
                    alignItems: 'center',
                    backgroundColor: '#3dc58d'
                }]}
            >
                <Text style={{ color: '#fff'}}>{getInitials()}</Text>
            </Box>
        );
    }

    return (
        <Image
            alt={getInitials()}
            style={[mainStyle.userCircle, props.style]}
            source={{ uri: avatarUrl }}
            onError={() => setFailed(true)}
        />
    );
};

export default UserImage;
